<template>
  <div>

    <b-card>
      <div>
        <div class="text-center text-md-left">
          <h3 class="text-primary mb-2">
            {{ loader ? 'Cargando eventos' : !calendario.length ? 'No hay eventos para mostrar' : 'Calendario disponible' }}
          </h3>

          <!-- Eventos -->
          <div class="text-left">
            <b-skeleton-wrapper :loading="loader">
              <!-- Loader -->
              <template #loading>
                <div
                  v-for="cont in 4"
                  :key="cont"
                >
                  <b-skeleton
                    :width="`${Math.floor(Math.random() * (100 - 25 + 1)) + 25}%`"
                    height="1.5em"
                    class="mb-50"
                  />
                  <b-skeleton
                    :width="`${Math.floor(Math.random() * (100 - 25 + 1)) + 25}%`"
                    height="4em"
                    class="mb-2"
                  />
                </div>
              </template>
              <!-- Eventos -->
              <app-timeline class="mb-2">
                <app-timeline-item
                  v-for="cal in calendario"
                  :key="`${cal.id}-${cal.fecha}`"
                  :title="cal.evento"
                  :subtitle="cal.descripcion"
                  :time="timestampToDate(cal.fecha)"
                  :rgb-color="`#${cal.color}`"
                />
              </app-timeline>
            </b-skeleton-wrapper>
          </div>

          <!-- Botón -->
          <div>
            <b-skeleton-wrapper :loading="loader">
              <!-- Loader -->
              <template #loading>
                <b-skeleton
                  type="button"
                  width="100%"
                />
              </template>
              <!-- Botón de crear/editar -->
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                block
                @click="showModalCalendario = true"
              >
                {{ !loader && !calendario.length ? 'Crear eventos' : 'Editar eventos' }}
              </b-button>
            </b-skeleton-wrapper>
          </div>
        </div>
      </div>
    </b-card>

    <!-- Modal para crear/editar eventos del calendario -->
    <modal-calendario
      v-model="showModalCalendario"
      :periodo="periodo || null"
      @reload-data="getScheadule(periodo)"
    />
  </div>
</template>

<script>
import { ref, watch, onMounted } from '@vue/composition-api'
import {
  BCard,
  BSkeletonWrapper,
  BSkeleton,
  BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { timestampToDate } from '@core/utils/filter'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { periodScheadule } from '@/views/public/oferta-academica/useDetalleOferta'
import ModalCalendario from './ModalCalendario.vue'

export default {
  components: {
    BCard,
    BSkeletonWrapper,
    BSkeleton,
    AppTimeline,
    AppTimelineItem,
    BButton,
    ModalCalendario,
  },
  directives: {
    Ripple,
  },
  props: {
    periodo: {
      type: [Number, null],
      default: 0,
    },
  },
  setup(props) {
    const toast = useToast()
    const tipos = ref([])
    const calendario = ref([])
    const loader = ref(false)
    const showModalCalendario = ref(false)

    const getScheadule = periodo => {
      loader.value = true
      periodScheadule(periodo).then(response => {
        loader.value = false
        tipos.value = response.tipo
        calendario.value = response.calendario
      }, error => {
        tipos.value = []
        calendario.value = []
        loader.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Calendario de periodo',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        },
        { timeout: 10000 })
      })
    }

    watch(() => props.periodo, id => {
      if (id && id !== null) getScheadule(id)
    })

    onMounted(() => {
      if (props.periodo && props.periodo !== null) getScheadule(props.periodo)
    })

    return {
      // Data
      tipos,
      calendario,
      showModalCalendario,

      // Methods
      getScheadule,

      // Loader
      loader,

      // Filters
      timestampToDate,
    }
  },
}
</script>
